import { Activity, BarChart3, LayoutDashboard, Link as LinkIcon, Network, UserPlus, Users } from "lucide-react";

export const managerNav = [
  { label: "Dashboard", to: "/manager/dashboard", icon: LayoutDashboard },
  { label: "My Clients", to: "/manager/clients", icon: Users },
  { label: "My Team", to: "/manager/team", icon: Network },
  { label: "Activity Feed", to: "/manager/activity", icon: Activity },
  { label: "Reports", to: "/manager/reports", icon: BarChart3 },
  { label: "Referral Links", to: "/manager/referral", icon: LinkIcon },
  { label: "Profile", to: "/manager/profile", icon: UserPlus },
];
